import '../../plugins/jquery.fullscreenmenu.js';

$('#js-fullScreenMenu').fullScreenMenu({
  breakpoint: 768
});
